/**
 * The TechTarget primary topic of the current page: the article's preferred topic or the community
 * page's own topic, pushed in the page.content event by templates/snippets/google_tag_manager.html.
 *
 * @param {Array} dataLayer The GTM dataLayer, usually window.dataLayer.
 * @returns {string} The most recently pushed primary_topic, or '' when there is none.
 */
export const getPrimaryTopic = (dataLayer) => {
  if (!Array.isArray(dataLayer)) {
    return '';
  }
  for (let i = dataLayer.length - 1; i >= 0; i -= 1) {
    const pageContent = dataLayer[i] && dataLayer[i]['page.content'];
    if (pageContent && pageContent.primary_topic) {
      return pageContent.primary_topic;
    }
  }
  return '';
};

export default getPrimaryTopic;
